import React from 'react';
import { bool, object } from 'prop-types';

import CSS from './styles.scss';

import Spinner from 'Shared/Spinner';
import Notifications from 'Shared/Notifications';
import Annotation from 'components/Annotation';
import VSReader from 'components/VSReader';


const EbookViews = ({ createPageViewerFail, isLoading, isOpen, styles }) => {
  return (
    <div className={ CSS['container'] } style={ styles } tabIndex="0">

      { isLoading
        ? <Spinner />
        : createPageViewerFail
          ? <Notifications />
          : null
      }

      { /*!isLoading && !createPageViewerFail
        ? <Bookmark />
        : null
      */}

      <VSReader />

      { isOpen
        ? <Annotation />
        : null
      }

      {/*<RightSidePanel />*/}

      {/*<Navigation />*/}

      {/*<FAB />*/}

    </div>
  );
};

EbookViews.propTypes = {
  isOpen: bool,
  styles: object
};


export default EbookViews;
